export default __webpack_public_path__ + "static/media/imc-gif.c141063b.gif";